import {h, Component} from 'preact';
import Menu from '../Menu';

class NavList extends Component {
    render ( {taxonomy} ) {
        return (
            <div>
                {taxonomy.map( Menu.itemGroup )}
            </div>
        );
    }
}

export default NavList;